'use client';
import { useContext, useEffect, useState } from "react";
import { Logo, SidebarToggleButton } from 'themes/jumbo/app/_components/_core';
import SignalrService from "services/SignalrService";
import { AuthUserPopover } from 'themes/jumbo/app/_components/popovers/AuthUserPopover';
//import { MessagesPopover } from 'themes/jumbo/app/_components/popovers/MessagesPopover';
//import { NotificationsPopover } from 'themes/jumbo/app/_components/popovers/NotificationsPopover';
import {
  useJumboLayout,
  useSidebarState,
} from 'themes/jumbo/@jumbo/components/JumboLayout/hooks';
import { useJumboTheme } from 'themes/jumbo/@jumbo/components/JumboTheme/hooks';
import { SIDEBAR_STYLES } from 'themes/jumbo/@jumbo/utilities/constants';
//import { TranslationPopover } from 'themes/jumbo/app/_components/popovers/TranslationPopover';
import { Stack, useMediaQuery } from '@mui/material';
import React from 'react';
import { Search, SearchIconButtonOnSmallScreen/*, AppTourButton*/} from './components';
import EventsEmitter from "events/EventsEmitter";
import { StorageUtils } from "services/UtilsService";
import { ThemeModeOption } from './components/ThemeModeOptions';
import { defaultProject, defaultProjectName } from "constants/ui";
import { ProjectSelector } from 'components';
import { getCachedData } from "api/Cache";
import { NotificationsPopover } from "../../popovers/NotificationsPopover";
import {AppContext} from "views/Loader";
import { useHistory } from 'react-router-dom';


const Header = () => {
	const { isSidebarStyle } = useSidebarState();
	const [filter, setFilter] = useState(StorageUtils.loadFromSessionStorage("filter") || defaultProject);
	const [projectName, setProjectName] = useState(defaultProjectName);
	const [searchVisibility, setSearchVisibility] = React.useState(false);
	const { theme } = useJumboTheme();
	const { headerOptions } = useJumboLayout();
	const data: any = getCachedData();
	const projects: any = data["projects"];
	const history = useHistory();

	useEffect(() => {
		if (filter !== "all" && filter !== defaultProject && Object.values(projects).length > 0) {
			if (filter.split(",").length > 1) {
				setProjectName("Multi");
			} else {
				if (projects[filter]) {
					setProjectName(projects[filter].name);
				} else {
					setFilter("all");
					setProjectName("All");
					StorageUtils.saveToSessionStorage("filter", defaultProject);
				}
			}
		} else {
			setProjectName("All");
		}
	}, [data.loaded, filter, projects]);

	useEffect(() => {
		const handleSignalrProjects = () => {
			console.log("filter:", filter);
			if (filter !== "all") {
				//SignalrService.cleanSubscription();
				SignalrService.subscribeToProject(filter);
			} else if (filter === "all" || filter === defaultProject) {
				Object.keys(projects).forEach((projectId: string) => {
					SignalrService.subscribeToProject(projectId);
				});
			} else if (Array.isArray(filter)) {
				const curfilter: any = filter;
				if (curfilter.split(",").length > 1) {
					curfilter.split(",").forEach((projectId: string) => {
						SignalrService.subscribeToProject(projectId);
					});
				}
			}
		};
		EventsEmitter.on("signalr", handleSignalrProjects);
		handleSignalrProjects();
		return () => {
			EventsEmitter.removeEventListener("signalr", handleSignalrProjects);
		};
	}, [filter, projects]);

	const isBelowLg = useMediaQuery(
		theme.breakpoints.down(/*headerOptions?.drawerBreakpoint ?? */'xl')
	);
	const handleSearchVisibility = React.useCallback((value: boolean) => {
		setSearchVisibility(value);
	}, []);

	const { 
		setTourActive,
		setRunTour,
	} = useContext<any>(AppContext);

	const handleAppTour = React.useCallback((value: boolean) => {
		history.push('/');
		setTimeout(() => {
			setTourActive(value);
			setRunTour(value);
		}, 250);
	}, []);


  	const selectProject = (event: any, projectId: string) => {
		if (event?.ctrlKey) {
			var projectList = "all";
			var filterArr = filter.split(",");
			if (projectId === "all") {
				setFilter(projectId);
			} else {
				if (filterArr.includes(projectId)) {
					SignalrService.unsubscribeToProject(projectId);
					
					var index = filterArr.findIndex((projId: string) => projId === projectId);
					if (index > -1) {
						filterArr.splice(index, 1);
					}
				} else {
					filterArr.push(projectId);
				}
				projectList = filterArr.join(",");
				setFilter(projectList);
			}
		} else {
			SignalrService.unsubscribeToProject(filter);
			projectList = projectId;
			setFilter(projectId);
			projectId !== filter && window.location.pathname.match('/catalog/') &&
				history.push(`/catalog/`)
		}
		setTimeout(() => {
			StorageUtils.saveToSessionStorage("filter", projectList);
			EventsEmitter.emit("updateFilter", projectList);
		}, 250);
	};

  	return (
		<React.Fragment>
			<SidebarToggleButton />
			{isSidebarStyle(SIDEBAR_STYLES.CLIPPED_UNDER_HEADER) && !isBelowLg && (
				<Logo sx={{ mr: 3, minWidth: 150 }} mode={theme.type} />
			)}
	
			<Search show={searchVisibility} onClose={handleSearchVisibility} />
			<Stack direction='row' alignItems='center' gap={1.25} sx={{ ml: 'auto' }}>
		
				<SearchIconButtonOnSmallScreen onClick={handleSearchVisibility} />
				<ThemeModeOption />
				<NotificationsPopover />
				{ !isBelowLg &&<ProjectSelector projectName={projectName} filter={filter} selectProject={selectProject} /> }
				<AuthUserPopover />
			</Stack>
		</React.Fragment>
	);
}

export { Header };
